export const getCloudflareImageUrl = (imageUrl: string) => {
  return `https://www.fender.com/cdn-cgi/image/format=auto/${imageUrl}`;
}